import { animationRotate } from '../utils';
import { Pane } from 'evergreen-ui';
import styled from 'styled-components';

const StyledLoader = styled(Pane)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #a7aaac;
  width: 320px;
  height: 320px;
  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(29, 136, 197, 0.1) 0%,
    rgba(29, 136, 197, 0.063) 26.04%,
    rgba(29, 136, 197, 0.04) 50.52%,
    rgba(29, 136, 197, 0) 100%
  );
  border-radius: 320px;
  font-size: 16px;
  font-weight: 500;
`;

const StyledLoadingAnimation = styled.svg`
  position: absolute;
  animation: ${animationRotate} 2s linear infinite;
  transition: all 0.5s;
  opacity: 0;
  width: 100px;

  &.loading {
    opacity: 1;
    width: 100%;
  }
`;
const LoadingAnimation = ({ status }) => (
  <StyledLoadingAnimation
    className={status}
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9183 142.96C2.96119 124.596 -0.0316918 103.89 3.35825 83.741C6.7482 63.5915 16.3514 45.0055 30.8247 30.5827C45.2979 16.1598 63.9173 6.62155 84.0785 3.30197C104.24 -0.0176216 124.934 3.04752 143.268 12.0687M193.464 70.5308C198.82 87.5162 199.445 105.64 195.274 122.954C191.102 140.268 182.292 156.118 169.788 168.801C157.285 181.484 141.562 190.52 124.309 194.937C107.056 199.355 88.9251 198.987 71.8652 193.874"
      stroke="url(#paint0_linear_1151_3790)"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1151_3790"
        x1="198"
        y1="106.533"
        x2="-95.9652"
        y2="76.3588"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E78850" />
        <stop offset="1" stopColor="#FFA46F" />
      </linearGradient>
    </defs>
  </StyledLoadingAnimation>
);

const StartLoader = ({ loading, statusText }) => {
  return (
    <Pane position="relative" display="flex" justifyContent="center" alignItems="center">
      <StyledLoader>
        <div>{statusText}</div>
        <LoadingAnimation status={loading ? 'loading' : ''} />
      </StyledLoader>
    </Pane>
  );
};

export default StartLoader;
